import { useTranslation } from 'react-i18next';
import PublishIcon from '@material-ui/icons/Publish';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Button } from '@material-ui/core';
import { ZaddonsCircularProgress } from '@commonClient2/components';
import { getImportScheduleStepsLabel } from '../../../../Enums/Helpers/LabellingHelper';
import './ExcelSelection.scss';

/**
 * @param {{
 *  handleDownloadExcelTemplate: Function;
 *  handleUploadExcelFile: Function;
 *  isUploadingSchedule: boolean;
 *  uploadScheduleProgressValue?: number;
 *  uploadScheduleStepCode?: ImportScheduleSteps;
 *  hasOnlyViewAccess?: boolean;
 *  disabled?: boolean;
 * }} props
 * @returns
 */
function ExcelSelection({
    handleDownloadExcelTemplate,
    handleUploadExcelFile,
    isUploadingSchedule,
    uploadScheduleProgressValue,
    uploadScheduleStepCode,
    hasOnlyViewAccess,
    disabled
}) {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'form.scheduleSelection.excel' });

    /**
     * @param {any} event
     */
    const onUploadExcelFileClick = (event) => {
        if (!isUploadingSchedule && event?.target?.files[0]) {
            if (typeof handleUploadExcelFile === 'function') {
                handleUploadExcelFile(event.target.files[0]);
                event.target.value = null;
            }
        }
    };

    const onDownloadExcelTemplateClick = () => {
        if (typeof handleDownloadExcelTemplate === 'function') {
            handleDownloadExcelTemplate();
        }
    };

    if (hasOnlyViewAccess) {
        return <></>;
    }

    return (
        <div className="ExcelBarSection">
            <div className="ExcelBarButtons">
                {
                    (!isUploadingSchedule && !disabled) && (
                        <input
                            accept=".xlsx"
                            style={{ display: 'none' }}
                            id="raised-button-file"
                            type="file"
                            onChange={(e) => onUploadExcelFileClick(e)}
                        />
                    )
                }
                <label htmlFor="raised-button-file">
                    <Button
                        component="span"
                        variant="outlined"
                        className="excel-button"
                        disabled={isUploadingSchedule || disabled}
                    >
                        {
                            isUploadingSchedule ? (
                                <>
                                    <ZaddonsCircularProgress
                                        size={30}
                                        value={uploadScheduleProgressValue}
                                        // @ts-ignore
                                        label={getImportScheduleStepsLabel(uploadScheduleStepCode)}
                                    />
                                </>
                            ) : (
                                <>
                                    <PublishIcon />
                                    {t('uploadExcel')}
                                </>
                            )
                        }
                    </Button>
                </label>
            </div>
            <div className="ExcelBarButtons">
                <Button
                    component="span"
                    variant="outlined"
                    className="excel-button"
                    onClick={() => onDownloadExcelTemplateClick()}
                    disabled={disabled}
                >
                    <GetAppIcon />
                    {t('downloadExcel')}
                </Button>
            </div>
        </div>
    );
}

export default ExcelSelection;
